import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs";
import { ScheduleServiceInterval } from "src/app/models/ScheduleServiceInterval";
import { Tool } from "src/app/models/Tool";
import { ToolUpdate } from "src/app/models/ToolUpdate";
import { ModalComponent, ModalService } from "src/app/services/modal.service";
import { ScheduleService } from "src/app/services/schedule.service";
import { ToolService } from "src/app/services/tool.service";

import { Service } from "./../../models/Service";

export type ServiceModalData = {
  tool: Tool;
  calibration: Service;
};

@Component({
  selector: "app-service-modal",
  templateUrl: "./service-modal.component.html",
  styleUrls: ["./service-modal.component.scss"],
  standalone: false,
})
export class ServiceModalComponent
  implements OnInit, ModalComponent<ServiceModalComponent, ServiceModalData>
{
  faSpinner = faSpinner;
  isLoading: boolean;
  frequencyList: number[];
  tool: Tool;
  service: Service;
  intervals: ScheduleServiceInterval[];

  constructor(
    private toolService: ToolService,
    public modalService: ModalService,
    private scheduleService: ScheduleService,
    @Inject(MAT_DIALOG_DATA) public data: ServiceModalData,
    public dialogRef: MatDialogRef<ServiceModalComponent, void>,
  ) {}

  ngOnInit() {
    this.tool = this.data.tool;
    this.service = Object.assign({}, this.data.calibration);
    this.setServiceFrequencyList();
    this.intervals = this.scheduleService.intervals;
  }

  updateServiceSchedule() {
    this.isLoading = true;
    this.toolService
      .updateServiceSchedule(
        this.tool.companyId,
        this.tool.serialNumber,
        new ToolUpdate({
          serviceNext: this.service.nextDate,
          serviceFrequency: this.service.frequency,
          serviceInterval: this.service.interval,
        }),
      )
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(() => {
        this.data.calibration.nextDate = this.service.nextDate;
        this.data.calibration.interval = this.service.interval;
        this.data.calibration.frequency = this.service.frequency;
        this.data.calibration.localizedInterval = this.intervals.find(
          (x) => x.id === this.service.interval,
        ).localizedTitle;

        this.modalService.close();
      });
  }

  setServiceFrequencyList() {
    this.frequencyList = this.scheduleService.getFrequencyList(this.service.interval);
    this.setFrequency();
    this.refreshNextScheduleDate();
  }

  setFrequency() {
    if (!this.frequencyList) return;

    if (!this.service.frequency) {
      this.service.frequency = 1;
      return;
    }

    if (this.service.frequency > Math.max(...this.frequencyList))
      this.service.frequency = Math.max(...this.frequencyList);
  }

  refreshNextScheduleDate() {
    this.service.nextDate = this.scheduleService.getNextScheduleDate(
      this.service.interval,
      this.service.frequency,
      this.service.lastDate,
    );
  }
}
